// bug fix-gallery-white-screen-null-wallpaper-settings: a default parameter
// (`= {}`) only fires for `undefined`, never for `null`. The API returns
// `wallpaper_settings: null` for any wheel that has no wheel_wallpaper_settings
// row (e.g. created before wallpaper customization ever ran), so destructuring
// straight off the parameter threw `Cannot read properties of null`, white-
// screening the whole /gallery/<uid> route.
export const getWheelBackground = (wallpaperSettings) => {
  const { bg_wallpaper, current_bg, segment_bg_color } =
    wallpaperSettings || {};
  return current_bg === 2 || current_bg === 3 ? bg_wallpaper : segment_bg_color;
};
